import { Broadcast } from "./broadcast";
import { EventBus } from "./eventbus";
import { debugInfo } from "../utils/log";

/** 设置Panda全局配置 */
export function setConfig(params) {
  if (params !== null && params !== void 0 && params.cookieKey) {
    window.__PANDA.cookieKey = params.cookieKey;
    debugInfo("setConfig cookieKey: " + params.cookieKey);
  }
  if (params && typeof params.logLevel !== 'undefined') {
    window.__PANDA.logLevel = params.logLevel;
  }
  if (params !== null && params !== void 0 && params.langList) {
    window.__PANDA.langList = params.langList;
    debugInfo("setConfig langList: " + JSON.stringify(params.langList));
  }
  if (params !== null && params !== void 0 && params.defaultLang) {
    window.__PANDA.defaultLang = params.defaultLang;
    debugInfo("setConfig defaultLang: " + params.defaultLang);
  }
}

// 兼容处理
export var pandaEvent = typeof BroadcastChannel === 'function' ? new Broadcast() : new EventBus();
export { i18nMapping } from "./mapping";